/* eslint-disable react-hooks/exhaustive-deps */
import { Grid, makeStyles } from '@material-ui/core';
import defaultCreateStyleImage from 'assets/img/defaultCreateStyle.png';
import deleteIcon from 'assets/img/deleteIcon.png';
import { ReactComponent as CreateStyleAddIcon } from 'assets/svg/createStyleAddIcon.svg';
import clsx from 'clsx';
import { useEffect, useMemo, useState } from 'react';
import Div100vh, { use100vh } from 'react-div-100vh';
import CloseIcon from '@material-ui/icons/Close';
import { FlexBox } from 'component/customize_style_component/styled_box';
import { Text, TextErr } from 'component/customize_style_component/styled_title';
import { Spinner } from 'react-bootstrap';
import { RootState, useAppSelector } from 'redux/store';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import { ReactComponent as RemoveLogo } from 'assets/svg/Photoroom-badge.svg';
import SwiperCore from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import isUrl from 'validator/lib/isURL';
import FormCreateStyle, { generateDefaultCreateStyle } from './FormCreateStyle';
import ModalAddImage from './ModalAddImage';
import './style.scss';
import StandardPopup from 'component/StandardPopup';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import { PATH } from '../../../routes/constant';
import { useDispatch, useSelector } from 'react-redux';
import { setEditStyleItemDisabled } from 'redux/create-style/create-style.slice';
import themes from 'styles/themes';
import UserType from 'constants/user';
import { STRINGS } from '../../../constants';
const useStyles = makeStyles(() => ({
    wrapper: {
        width: '100%',
        position: 'relative',
    },

    imageWrapper: {
        width: '112px',
        height: '110px',
        position: 'relative',
        borderRadius: '16px',
        background: themes.palette.common.white,
        padding: '8px',
        display: 'flex!important',
        marginLeft: '-1px',
    },
    imageExistWrapper: {
        background: '#fff',
    },
    imageCloseBtn: {
        position: 'absolute',
        top: 0,
        right: 0,
        width: '30px!important',
        height: '30px',
        cursor: 'pointer',
    },
    activeItem: {
        border: `5px solid ${themes.palette.info.light}`,
    },
    editedStyleItemImage: {
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    slickWrapper: {
        '& .slick-slider': {
            height: '109px',
            overflow: 'hidden',
        },
        '& .slick-slide': {
            height: '120px',
            // margin: "0px 4px",
            '& > div > div': {
                display: 'flex!important',
                justifyContent: 'center',
            },
        },
        '& .slick-list': {
            margin: '0px',
        },
        '& img': {
            width: '100%',
        },
        position: 'relative',

        '& .selectedZone': {
            position: 'absolute',
            height: '118px',
            width: '120px',
            top: 0,
            left: '50%',
            transform: 'translate(-50%,-4px)',
            border: `2px solid ${themes.palette.info.light}`,
            borderRadius: '20px',
            pointerEvents: 'none',
            zIndex: 99,
        },
        // "& .slick-cloned": {
        //   display: "none!important",
        // },
    },
    createStyleAddIcon: {
        position: 'absolute',
        top: '70%',
        left: '50%',
        transform: 'translate(-50%,0)',
        fill: '#fff',
    },
    formWrapper: {
        padding: '0px 24px',
        margin: '20px 0px',
    },
    input: {
        fontFamily: 'PoppinsRegular',
        fontWeight: 400,
        color: '#fff',
        border: 'none!important',
        width: '90%',
        textOverflow: 'ellipsis',
        marginTop: '12px',
        '&::placeholder ': {
            fontFamily: 'PoppinsRegular',
            fontWeight: 600,
            fontSize: '16px',
            lineHeight: '24px',
            color: '#fff',
            opacity: 0.5,
        },
    },
    menuItem: {
        fontFamily: 'PoppinsRegular',
        fontWeight: 400,
        fontStyle: 'normal',
        height: '20px',
        fontSize: '14px',
        display: 'flex',
        alignItems: 'center',
    },

    errorImg: {
        padding: '10px 24px 0',
    },
}));

interface IAddCreateStyleProps {
    handleCloseModal: () => void;
    styleData?: any;
}

const displayNumCount = 4;

const AddCreateStyleItem = ({ handleCloseModal, styleData }: IAddCreateStyleProps) => {
    const location = useLocation();
    const match = useRouteMatch<any>(`${PATH.EDIT_ITEM}/:taffiId`);
    const isItemWithoutStyle = location.pathname === PATH.CREATE_ITEM || match?.params.taffiId;
    const { imageJson, currentEditingItemId, items } = useAppSelector((state: RootState) => state.createStyle);
    const height = use100vh();
    const [swiperInstance, setSwiperInstance] = useState<SwiperCore>();
    const classes = useStyles();
    const [isOpen, setIsOpen] = useState(false);
    const [selectedImageIndex, setSelectedImageIndex] = useState<number>(0);
    const dispatch = useDispatch();
    const editStyleItemDisabled = useSelector((state: RootState) => state.createStyle.editStyleItemDisabled);
    const me = useSelector((state: RootState) => state.userDetail.me);
    const [modalShow, setModalShow] = useState({
        show: false,
        title: 'You may lose any unsaved changes on this page. Are you sure you want to leave this page?',
        content: '',
        button1: 'Yes',
        button2: '',
        path: '',
        type: '',
        buttonCancel: 'No',
        closeButton: false,
    });

    const currentItemValues = useMemo(() => {
        if (currentEditingItemId) {
            const currentItem = items.find((item) => item.id === currentEditingItemId);
            return { id: currentEditingItemId, ...currentItem?.data };
        }
        if (match?.params.taffiId) {
            return styleData;
        }
        return generateDefaultCreateStyle();
    }, [items]);

    useEffect(() => {
        if (currentEditingItemId) {
            const matchImageOnCanvas = imageJson.find((image) => image.itemId === currentEditingItemId);
            if (matchImageOnCanvas && currentItemValues) {
                const itemImageOnCanvasIndex = currentItemValues.images?.findIndex(
                    (image) => image === matchImageOnCanvas.url,
                );
                if (itemImageOnCanvasIndex) {
                    setSelectedImageIndex(itemImageOnCanvasIndex);
                }
            }
        }
    }, [currentItemValues]);

    const [listImages, setListImage] = useState<string[]>(currentItemValues ? currentItemValues.images : []);

    const itemImages: string[] = useMemo(() => {
        if (listImages?.length < displayNumCount) {
            return [
                ...listImages,
                ...Array.from(
                    {
                        length: displayNumCount - listImages.length,
                    },
                    () => '',
                ),
            ];
        }

        const placeHolderImage = listImages?.find((image) => image === '');
        if (placeHolderImage) {
            return [...listImages];
        }

        return listImages?.length ? [...listImages, ''] : [];
    }, [listImages]);

    useEffect(() => {
        const selectedIndex = selectedImageIndex > 0 ? selectedImageIndex - 1 : itemImages.length - 1;
        if (swiperInstance) {
            swiperInstance.slideToLoop(selectedIndex);
        }
    }, [swiperInstance, itemImages]);

    const _deleteCreateStyleImage = (id) => {
        setListImage(
            listImages.filter((img) => {
                return img !== id;
            }),
        );
    };

    const [loading, setLoading] = useState(false);
    const handleChangeSlide = (e) => {
        const selectedIndex = e.realIndex > itemImages.length - 2 ? 0 : e.realIndex + 1;
        setSelectedImageIndex(selectedIndex);
    };

    useEffect(() => {
        if (swiperInstance) {
            swiperInstance.on('slideChangeTransitionEnd', (e) => {
                handleChangeSlide(e);
            });
        }
    }, [swiperInstance]);

    useEffect(() => {
        if (swiperInstance && itemImages.length) {
            swiperInstance.slideToLoop(selectedImageIndex === 0 ? itemImages.length - 1 : selectedImageIndex - 1);
            swiperInstance.on('slideChangeTransitionEnd', (e) => {
                handleChangeSlide(e);
            });
        }
    }, [itemImages]);
    const [emptyImg, setEmptyImg] = useState(false);
    useEffect(() => {
        if (itemImages && itemImages.length > 0 && itemImages.filter((d) => d !== '').length > 0) {
            setEmptyImg(false);
        }
    }, [itemImages]);

    const history = useHistory();

    const isValidUrl = (testedUrl: string) => {
        if (isUrl(testedUrl)) {
            return true;
        }

        // For local development by pass
        return testedUrl.includes('http');
    };

    const renderAddNewItemImageSwiper = () => {
        return (
            <>
                <Swiper
                    direction="horizontal"
                    slidesPerView={3}
                    loop={true}
                    onSwiper={(swiper) => setSwiperInstance(swiper)}
                >
                    {itemImages.map((image, index) => {
                        return (
                            <SwiperSlide key={index} style={{ display: 'flex', justifyContent: 'center' }}>
                                {image !== '' ? (
                                    <div className={clsx(classes.imageWrapper, classes.imageExistWrapper)}>
                                        {isValidUrl(image) && image && <img alt="" src={image} />}
                                        {!editStyleItemDisabled && (
                                            <img
                                                src={deleteIcon}
                                                alt=""
                                                className={classes.imageCloseBtn}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    _deleteCreateStyleImage(image);
                                                }}
                                            />
                                        )}
                                    </div>
                                ) : (
                                    <div className={clsx(classes.imageWrapper)}>
                                        <img alt="" src={defaultCreateStyleImage} />
                                        <CreateStyleAddIcon
                                            onClick={() => {
                                                setSelectedImageIndex(index);
                                                setIsOpen(true);
                                            }}
                                            className={classes.createStyleAddIcon}
                                            display={editStyleItemDisabled ? 'none' : 'block'}
                                        />
                                    </div>
                                )}
                            </SwiperSlide>
                        );
                    })}
                </Swiper>

                <div className={'selectedZone'} />
            </>
        );
    };

    return (
        <>
            <div className={classes.wrapper}>
                <Div100vh
                    style={{
                        height: `${height}`,
                        backgroundColor: themes.palette.primary.light,
                        overflowY: 'scroll',
                    }}
                >
                    <Grid
                        container
                        style={{
                            padding: '10px',
                            marginBottom: '-1px',
                            position: 'relative',
                        }}
                    >
                        <Grid
                            item
                            xs={12}
                            xl={12}
                            sm={12}
                            md={12}
                            lg={12}
                            style={{
                                textAlign: 'center',
                                fontFamily: 'Fraunces_120pt_SuperSoft_Wonky-Regular',
                                fontWeight: 400,
                                fontSize: '24px',
                                color: themes.palette.primary.main,
                                position: 'relative',
                            }}
                        >
                            {editStyleItemDisabled
                                ? 'Item'
                                : currentEditingItemId || match?.params.taffiId
                                    ? STRINGS.EDIT_ITEM
                                    : 'Add New Item'}
                            <CloseIcon
                                style={{
                                    color: themes.palette.primary.main,
                                    position: 'absolute',
                                    right: '10px',
                                    top: '50%',
                                    transform: 'translate(0, -50%)',
                                }}
                                onClick={() => {
                                    if (me?.userType === UserType.Customer) {
                                        handleCloseModal();
                                    } else if (isItemWithoutStyle) {
                                        history.push(PATH.HOME);
                                    } else if (editStyleItemDisabled) {
                                        dispatch(setEditStyleItemDisabled(false));
                                        handleCloseModal();
                                    } else {
                                        setModalShow({ ...modalShow, show: true });
                                    }
                                }}
                            />
                        </Grid>
                    </Grid>
                    <div className={classes.slickWrapper}>
                        {
                            // currentEditingItemId ? renderItemImageEditSwiper() : renderAddNewItemImageSwiper()
                            renderAddNewItemImageSwiper()
                        }
                    </div>
                    {emptyImg && (
                        <div className={classes.errorImg}>
                            <TextErr>Please add item image.</TextErr>
                        </div>
                    )}
                    <FormCreateStyle
                        styleData={styleData}
                        currentList={itemImages}
                        initialItemValues={currentItemValues}
                        setLoadingRemove={setLoading}
                        disabledButton={emptyImg}
                        setEmptyImg={setEmptyImg}
                        handleClose={() => handleCloseModal()}
                        selectedIndex={selectedImageIndex}
                        setSelectedIndex={setSelectedImageIndex}
                        setListImage={setListImage}
                    />
                    <ModalAddImage
                        currentList={itemImages}
                        isOpen={isOpen}
                        setIsOpen={setIsOpen}
                        handleSubmit={setListImage}
                        selectedIndex={selectedImageIndex}
                    />
                </Div100vh>
                {loading && (
                    <>
                        <Div100vh
                            style={{
                                top: 0,
                                left: 0,
                                width: '100%',

                                zIndex: 99,
                                position: 'absolute',
                            }}
                            className="background_loading_style"
                        >
                            <FlexBox
                                flexdirection="column"
                                justifycontent="center"
                                alignitems="center"
                                style={{ height: '100%' }}
                            >
                                <Spinner animation="border" style={{ width: 80, height: 80, color: 'white' }} />
                                <Text size="18px" color="white" margin="20px 0 50px 0 ">
                                    Processing item...
                                </Text>
                            </FlexBox>
                        </Div100vh>
                        {!isItemWithoutStyle && (
                            <div style={{ width: '100%', position: 'absolute', zIndex: 100, bottom: 50 }}>
                                <FlexBox
                                    flexdirection="column"
                                    justifycontent="center"
                                    alignitems="center"
                                    style={{ height: '100%' }}
                                >
                                    <div style={{ background: 'white', width: '170px' }}>
                                        <RemoveLogo
                                            onClick={() => window.open('https://www.photoroom.com/', '_blank')}
                                            style={{ width: '100%', height: 'auto' }}
                                        />
                                    </div>
                                </FlexBox>
                            </div>
                        )}
                    </>
                )}
                <StandardPopup
                    show={modalShow.show}
                    onHide={() => setModalShow({ ...modalShow, show: false })}
                    title={modalShow.title}
                    content={modalShow.content}
                    button1={modalShow.button1}
                    buttonCancel={modalShow.buttonCancel}
                    // path={modalShow.path}
                    type={modalShow.type as any}
                    closeButton={modalShow.closeButton}
                    // onEvent={handleCloseModal}
                    onFirstButtonClick={handleCloseModal}
                    onSecondButtonClick={() => {
                        dispatch(setEditStyleItemDisabled(false));
                        if (modalShow.path) history.push(modalShow.path);
                    }}
                />
            </div>
        </>
    );
};
export default AddCreateStyleItem;
